import ACTIONS from "./BlocklistActionTypes";

export const getBlocklistListRequest = (payload) => ({
  type: ACTIONS.GET_BLOCKLIST_REQUEST,
  payload,
});

export const getBlocklistListResponse = (payload) => ({
  type: ACTIONS.GET_BLOCKLIST_RESPONSE,
  payload,
});

export const postBockListRequest = (payload) => ({
  type: ACTIONS.POST_BLOCKLIST_REQUEST,
  payload,
});

export const postBlockListResponse = (payload) => ({
  type: ACTIONS.POST_BLOCKLIST_RESPONSE,
  payload,
});

export const postBlockListResponseClear = () => ({
  type: ACTIONS.POST_BLOCKLIST_RESPONSE_CLEAR,
});

export const deleteBlockListRequest = (payload) => ({
  type: ACTIONS.DELETE_BLOCKLIST_REQUEST,
  payload,
});

export const deleteBlockListResponse = (payload) => ({
  type: ACTIONS.DELETE_BLOCKLIST_RESPONSE,
  payload,
});

export const deleteBlockListResponseClear = () => ({
  type: ACTIONS.DELETE_BLOCKLIST_RESPONSE_CLEAR,
});
